import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1bcaf890"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcaf890')) {
      api.createRecord('1bcaf890', component.options)
    } else {
      api.reload('1bcaf890', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=1bcaf890", function () {
      api.rerender('1bcaf890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/sku/ordinary/add.vue"
export default component.exports